import React, { useEffect, useRef, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { useAuth } from "../../auth/useAuth";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const emailRef = useRef();
  const passwordRef = useRef();

  const [error, setError] = useState({ email: false, password: false });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const logoutReason = sessionStorage.getItem("authLogoutReason");
    if (logoutReason) {
      setErrorMessage(logoutReason);
      sessionStorage.removeItem("authLogoutReason");
    }
  }, []);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = emailRef.current?.value;
    const password = passwordRef.current?.value;

    // ---------- Validation ----------
    if (!email && !password) {
      setErrorMessage("Email and Password cannot be empty");
      setError({ email: true, password: true });
      return;
    } else if (!email) {
      setErrorMessage("Email cannot be empty");
      setError({ email: true, password: false });
      return;
    } else if (!password) {
      setErrorMessage("Password cannot be empty");
      setError({ email: false, password: true });
      return;
    }

    try {
      setLoading(true);
      setErrorMessage("");

      const response = await axios.post(
        "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword",
        {
          email,
          password,
          returnSecureToken: true,
        },
        {
          params: {
            key: process.env.REACT_APP_FIREBASE_API_KEY,
          },
        }
      );

      const { idToken, refreshToken } = response.data;

      // ✅ Delegate EVERYTHING to AuthContext
      await login({ idToken, refreshToken });

      navigate("/overview", { replace: true });
    } catch (err) {
      const firebaseError = err?.response?.data?.error?.message;

      if (firebaseError === "INVALID_PASSWORD") {
        setErrorMessage("Invalid password");
      } else if (firebaseError === "EMAIL_NOT_FOUND") {
        setErrorMessage("Email not registered");
      } else if (firebaseError === "USER_DISABLED") {
        setErrorMessage("User account disabled");
      } else {
        setErrorMessage("Login failed. Please try again later.");
      }

      setError({ email: false, password: false });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: "100%", height: "100%", display: "flex" }}>
      <div style={{ width: isMobile ? "0" : "60%", height: "100vh" }}>
        <img
          src="/combine_image.png"
          alt="Dashboard Illustration"
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      <div
        style={{
          position: "relative",
          flex: 1,
          height: "100vh",
          backgroundColor: "#000",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1.87rem",
        }}
      >
        <p
          style={{
            margin: 0,
            color: "#FFF",
            fontFamily: "TASA Explorer",
            fontSize: "2.25rem",
            fontWeight: 500,
            marginTop: "1.94rem",
          }}
        >
          TrackCoreData
        </p>

        <form 
          onSubmit={handleSubmit}
          style={{
            width: "21.5625rem",
            paddingTop: "2.75rem",
            paddingBottom: "2rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "1px solid rgba(255, 255, 255, 0.16)",
            borderRadius: "1.352rem",
            background: "rgba(22, 21, 21, 0.85)",
          }}
        >
          <img
            src="/Coredata_Logo_black.svg"
            alt=""
            style={{ width: "14.8125rem", height: "3.75rem" }}
          />

          {/* EMAIL */}
  <div
            style={{
              textAlign: "left",
              width: "19.9375rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <p
              style={{
                margin: 0,
                color: "rgba(255, 255, 255, 0.90)",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.01419rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                marginTop: "2.75rem",
              }}
            >
              UserName
            </p>
            <input
              type="email"
              style={{
                display: "flex",
                color: "#FFF",
                padding: "1.35219rem",
                justifyContent: "space-between",
                alignItems: "center",
                flexShrink: 0,
                borderRadius: "0.45075rem",
                border: error["email"]
                  ? "1px solid #FF4C4C"
                  : "0.901px solid rgba(255, 255, 255, 0.14)",
                background: "#151515",
              }}
              onChange={() => {
                setErrorMessage("");
                setError((prev) => ({
                  ...prev,
                  email: false,
                  password: false,
                }));
              }}
              ref={emailRef}
            />
          </div>

         <div
            style={{
              textAlign: "left",
              width: "19.9375rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <p
              style={{
                margin: 0,
                color: "rgba(255, 255, 255, 0.90)",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.01419rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                marginTop: "2.19rem",
              }}
            >
              Password
            </p>

            <div style={{ position: "relative", width: "100%" }}>
              <input
                ref={passwordRef}
                type={showPassword ? "text" : "password"}
                onChange={() => {
                  setErrorMessage("");
                  setError((prev) => ({
                    ...prev,
                    email: false,
                    password: false,
                  }));
                }}
                style={{
                  width: "100%",
                  padding: "1.35219rem",
                  paddingRight: "3rem", // extra space for the icon
                  color: "#FFF",
                  borderRadius: "0.45075rem",
                  border: error["password"]
                    ? "1px solid #FF4C4C"
                    : "0.901px solid rgba(255, 255, 255, 0.14)",
                  background: "#151515",
                  boxSizing: "border-box",
                }}
              />
              <span
                onClick={handleClickShowPassword}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "1rem",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#FFF",
                }}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </span>
            </div>
          </div>

          {errorMessage && (
            <div style={{ color: "#FF4C4C", marginTop: "0.5rem" }}>
              {errorMessage}
            </div>
          )}

          <button
            type="submit"
            style={{
              marginTop: "1.5rem",
              width: "8.11rem",
              height: "2.7rem",
              borderRadius: "0.45rem",
              border: "1px solid rgba(227, 133, 0, 0.8)",
              background: "rgba(227, 133, 0, 0.07)",
              color: "#E38500",
              cursor: "pointer",
            }}
          >
            {loading ? (
              <CircularProgress size="1rem" thickness={5} />
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
